import AddCommentIcon from '@mui/icons-material/AddComment';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import ArticleIcon from '@mui/icons-material/Article';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import BorderInnerIcon from '@mui/icons-material/BorderInner';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DataObjectIcon from '@mui/icons-material/DataObject';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import { IconButton, List, ListItem, ListItemIcon, ListItemText, Stack, styled } from '@mui/material';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import TextField from '@mui/material/TextField';
import { ReactNode, useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GiAcousticMegaphone } from 'react-icons/gi';
import { useParams } from 'react-router';
import { UserContext } from '../../../context/UserContext';
import { AuthContext } from '../../../context/AuthContext';
import { WebFormContext } from '../../../context/WebFormContext';
import { ChamadoChecklist, modeloType, SubItemFormFilling } from '../../../types/new-form-filling/types';
import { getBase64 } from '../../Filling/Subitens/GetBase64';
import CheckIcon from '../CheckIcon';
import OpenTicketModal from '../modal/OpenTicketModal ';

export type fileTypeObj = { path: string; nome: string; type: string };

export default function AdditionalInfo({ subItem }: { subItem: SubItemFormFilling }) {
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [comentario, setComentario] = useState<string | null>(null);
  const [chamados, setChamados] = useState<ChamadoChecklist[]>(subItem.chamados || []);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const { logado } = useContext(UserContext);
  const { session } = useContext(AuthContext);
  const userId = session?.userId;
  const [fotosLocal, setFotosLocal] = useState<string[]>(() => subItem.img ?? []);
  const [arquivosLocal, setArquivosLocal] = useState<File[]>([]);
  const { webForm, fotos, setFotos, arquivos, setArquivos, ForceUpdate, setWebForm } = useContext(WebFormContext);
  const [sizeValue, setSizeValue] = useState(0);

  const { formId } = useParams();
  const { t } = useTranslation('translation');
  const subItemRef = useRef(subItem);
  const fotosRef = useRef<string[]>(subItem.img ?? []);

  useEffect(() => {
    console.log('fotosLocal', fotosLocal);
    console.log('fotos', fotos);
    console.log('form', webForm);
  }, [fotos, fotosLocal, webForm]);

  const updateSubItemImages = (images: string[]) => {
    fotosRef.current = images;
    setFotosLocal(images);
    setWebForm((previousWebForm: typeof webForm) => {
      let updated = false;

      const updateSubitens = (subitens: SubItemFormFilling[] = []) => subitens.map((currentSubItem) => {
        if (updated || currentSubItem !== subItemRef.current) return currentSubItem;

        updated = true;
        const nextSubItem = { ...currentSubItem, img: images };
        subItemRef.current = nextSubItem;
        return nextSubItem;
      });

      const itens = previousWebForm.itens.map((item) => ({
        ...item,
        subitens: updateSubitens(item.subitens),
        ocorrencias: item.ocorrencias?.map((ocorrencia) => ({
          ...ocorrencia,
          subitens: updateSubitens(ocorrencia.subitens),
        })),
      }));

      return updated ? { ...previousWebForm, itens } : previousWebForm;
    });
  };

  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  useEffect(() => {
    if (subItem.tipo === 'avaliacao' || subItem.tipo === 'multiple') {
      if (subItem.ocorrencia) {
        setComentario(subItem.ocorrencia as string);
      }
    }
    if (subItem.obs) {
      setComentario(subItem.obs);
    }
    if (subItem.arquivos && arquivos.length > 0) {
      subItem.arquivos.forEach((file) => {
        let newName = file.nome;
        arquivos.filter((arquivo) => arquivo.name === file.path.split("/")[3]).forEach((ele) => {
          const newFile = new File([ele], newName);
          setArquivosLocal((prev: File[]) => prev ? [...prev, newFile] : [newFile]);
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    subItem.chamados = chamados;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chamados]);

  useEffect(() => {
    if (CheckIcon(subItem, fotosLocal) === 'ok') {
      subItem.checked = true;
    }
    if (CheckIcon(subItem, comentario) === 'ok') {
      subItem.checked = true;
    }
    if (CheckIcon(subItem, arquivosLocal) === 'ok') {
      subItem.checked = true;
    }
    ForceUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comentario, fotosLocal, arquivosLocal]);

  const getFileType = (value: string) => {
    const fileName = value?.substring(value.lastIndexOf('.') + 1);
    switch (fileName) {
      case 'pdf':
        return (<PictureAsPdfIcon />);
      case 'doc': case 'docx': case 'txt':
        return (<ArticleIcon />);
      case 'xls': case 'xlsx':
        return (<BorderInnerIcon />);
      case 'json':
        return (<DataObjectIcon />);
      case 'audio':
        return (<AudioFileIcon />);
      case 'video':
        return (<VideoFileIcon />);
    }
  };

  const renderImages = (File: FileList | null) => {
    if (File) {
      Array.from(File).map(e => getBase64(e, (i) => {
        updateSubItemImages([...fotosRef.current, i]);
      }));
    }
  };

  const compressImage = async (file: File, { quality = 1, type = file.type }) => {
    const imageBitmap = await createImageBitmap(file);

    const canvas = document.createElement('canvas');
    canvas.width = imageBitmap.width;
    canvas.height = imageBitmap.height;
    const ctx = canvas.getContext('2d');
    ctx?.drawImage(imageBitmap, 0, 0);

    return await new Promise((resolve) =>
      canvas.toBlob(resolve, type, quality)
    );
  };

  const renderDetails = () => {
    switch (selectedOption) {
      case 'arquivo':
        return (
          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Button
              disabled={sizeValue >= 100000000}
              sx={{ backgroundColor: '#643E91' }}
              component="label"
              role={undefined}
              variant="contained"
              tabIndex={-1}
              startIcon={<CloudUploadIcon />}
            >
              Enviar arquivos
              <VisuallyHiddenInput
                value=''
                accept="video/*, .doc, .docx, .xls, .xlsx, audio/*, .pdf, .txt"
                type="file"
                onChange={(event) => {
                  if (event.target.files) {
                    if ((event.target.files[0].size + sizeValue) > 100000000) {
                      alert('Limite de 100mb por subitem atingido');
                    }
                    else if (event.target.files[0].size > 20000000) {
                      alert('Arquivo excede 20mb');
                    } else {
                      Array.from(event.target.files).forEach((file) => {
                        setSizeValue(sizeValue + file.size);
                        const fileType = file.name.substring(file.name.lastIndexOf('.') + 1);
                        let newName = crypto.randomUUID() + '.' + fileType;
                        setArquivosLocal((prev: File[]) => prev ? [...prev, file] : [file]);
                        const newFile = new File([file], newName, { type: file.type });
                        setArquivos((prev: File[]) => prev ? [...prev, newFile] : [newFile]);
                        if (userId) {
                          newName = `checklisthistorico/${userId}/${webForm.inicio}/${newName}`;
                        } else if (formId) {
                          newName = `checklisthistorico/${formId}/${webForm.inicio}/${newName}`;
                        }
                        if (subItem.arquivos) {
                          subItem.arquivos = [...subItem.arquivos, { path: newName, nome: file.name, type: file.type }];
                        } else {
                          subItem.arquivos = [{ path: newName, nome: file.name, type: file.type }];
                        }
                      });
                    }
                  }
                }}
                multiple
              />
            </Button>
            {arquivosLocal &&
              <List>
                {arquivosLocal?.map((file: File, i) => (
                  <ListItem key={i}>
                    <ListItemIcon>
                      {getFileType(file.name)}
                    </ListItemIcon>
                    <ListItemText
                      primary={file.name}
                    />
                    <IconButton
                      onClick={() => {
                        sizeValue - file.size < 0 ? setSizeValue(0) : setSizeValue(sizeValue - file.size);
                        setArquivosLocal(arquivosLocal.filter((_ele, ind) => ind !== i));
                        subItem.arquivos = subItem.arquivos?.filter((_ele, ind) => ind !== i);
                        if (subItem.arquivos) {
                          for (const valor of subItem?.arquivos) {
                            setArquivos(arquivos.filter((ele) => ele.name !== valor?.path.split("/")[3]));
                          }
                        }
                      }}
                      color="error"
                    >
                      <RemoveCircleOutlineIcon />
                    </IconButton>
                  </ListItem>
                ))}
              </List>}
          </Stack>
        );
      case 'foto':
        return (
          <Stack
            spacing={2}
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Stack direction='row' alignItems='flex-start' justifyContent='flex-start' spacing={2}>
              {navigator.maxTouchPoints > 0
                && <Button
                  disabled={sizeValue >= 100000000}
                  sx={{ backgroundColor: '#643E91' }}
                  component="label"
                  role={undefined}
                  variant="contained"
                  tabIndex={-1}
                  startIcon={<CameraAltIcon />}
                >
                  Abrir câmera
                  <VisuallyHiddenInput
                    capture
                    type="file"
                    accept="image/*"
                    value=''
                    onChange={async (event) => {
                      if (event.target.files) {
                        if ((event.target.files[0].size + sizeValue) > 100000000) {
                          alert('Limite de 100mb por subitem atingido');
                        }
                        else if (event.target.files[0].size > 20000000) {
                          alert('Arquivo excede 20mb');
                        } else {
                          if (logado) {
                            Array.from(event.target.files).forEach((file) => {
                              setSizeValue(sizeValue + file.size);
                              let newName = crypto.randomUUID() + '.webp';
                              const newFile = new File([file], newName, { type: file.type });
                              setFotos((prev: File[]) => prev ? [...prev, newFile] : [newFile]);
                              if (userId) {
                                newName = `checklisthistorico/${userId}/${webForm.inicio}/${newName}`;
                                if (subItem.img) {
                                  subItem.img = [...subItem.img, newName];
                                } else {
                                  subItem.img = [newName];
                                }
                              }
                              updateSubItemImages([...fotosRef.current, newName]);
                            });
                          } else {
                            const files: FileList | null = event.target.files;
                            if (files) {
                              const filesArray: File[] = Array.from(files).map(file => file);
                              for (const file of filesArray) {
                                const compressedFile = await compressImage(file, {
                                  quality: 0.1,
                                  type: 'image/jpeg',
                                });
                                renderImages([compressedFile] as unknown as FileList);
                              }
                            }
                          }
                        }
                      }
                    }}
                    multiple
                  />
                </Button>}
              <Button
                disabled={sizeValue >= 100000000 || (navigator.maxTouchPoints > 0 && !subItem.galeriaFoto)}
                sx={{ backgroundColor: '#643E91' }}
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<AddPhotoAlternateIcon />}
              >
                {navigator.maxTouchPoints > 0 ? 'Abrir galeria' : t('formFilling.uploadImages')}
                <VisuallyHiddenInput
                  type="file"
                  accept="image/*"
                  value=''
                  onChange={async (event) => {
                    if (event.target.files) {
                      if ((event.target.files[0].size + sizeValue) > 100000000) {
                        alert('Limite de 100mb por subitem atingido');
                      }
                      else if (event.target.files[0].size > 20000000) {
                        alert('Arquivo excede 20mb');
                      } else {
                        if (logado) {
                          Array.from(event.target.files).forEach((file) => {
                            setSizeValue(sizeValue + file.size);
                            let newName = crypto.randomUUID() + '.webp';
                            const newFile = new File([file], newName, { type: file.type });
                            setFotos((prev: File[]) => prev ? [...prev, newFile] : [newFile]);
                            if (userId) {
                              newName = `checklisthistorico/${userId}/${webForm.inicio}/${newName}`;
                              if (subItem.img) {
                                subItem.img = [...subItem.img, newName];
                              } else {
                                subItem.img = [newName];
                              }
                            }
                              updateSubItemImages([...fotosRef.current, newName]);
                          });
                        } else {
                          const files: FileList | null = event.target.files;
                          if (files) {
                            const filesArray: File[] = Array.from(files).map(file => file);
                            for (const file of filesArray) {
                              const compressedFile = await compressImage(file, {
                                quality: 0.1,
                                type: 'image/jpeg',
                              });
                              renderImages([compressedFile] as unknown as FileList);
                            }
                          }
                        }
                      }
                    }
                  }}
                  multiple
                />
              </Button>
            </Stack>
            <Stack direction='column' width='100%' alignItems={navigator.maxTouchPoints > 0 ? 'center' : 'flex-start'} justifyContent='flex-start'>
              {fotosLocal &&
                <ImageList
                  gap={5} cols={navigator.maxTouchPoints > 0 ? 2 : 4}
                  rowHeight={150}
                >
                  {fotosLocal?.map((foto, i) => {
                    const fotoNome = foto.includes('/') ? foto.split('/').pop() as string : foto;
                    const fotoArquivo = fotos.find((arquivo) => arquivo.name === fotoNome);
                    const fotoSrc = logado
                      ? (fotoArquivo ? URL.createObjectURL(fotoArquivo) : foto)
                      : foto;
                    return (
                      <ImageListItem key={logado ? `${fotoNome}|${i}` : i} sx={{ width: '150px', height: '150px' }}>
                        <img
                          width={'150px'}
                          height={'150px'}
                          style={{
                            width: '150px',
                            borderRadius: 2,
                            objectFit: 'contain',
                            maxWidth: '150px',
                            maxHeight: '150px'
                          }}
                          loading='lazy'
                          src={fotoSrc}
                          alt={`imagem ${i}`}
                        />
                        <ImageListItemBar
                          sx={{
                            background:
                              'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
                              'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
                          }}
                          position="top"
                          actionIcon={
                            <IconButton
                              color='error'
                              onClick={() => {
                                const fotoSize = fotoArquivo?.size || 0;
                                sizeValue - fotoSize < 0 ? setSizeValue(0) : setSizeValue(sizeValue - fotoSize);
                                updateSubItemImages(fotosRef.current.filter((_ele, index) => index !== i));
                                if (logado) {
                                  setFotos(fotos.filter((ele) => ele.name !== fotoNome));
                                }
                              }}
                            >
                              <RemoveCircleOutlineIcon />
                            </IconButton>
                          }
                          actionPosition="left"
                        />
                      </ImageListItem>
                    );
                  })}
                </ImageList>}
            </Stack>
          </Stack>
        );
      case 'comentario':
        return (
          <Stack
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <TextField
              required={subItem?.obrigatoriedade?.ocorrencia}
              multiline
              fullWidth
              maxRows={5}
              rows={4}
              label={t('notifications.ticket.Comentario')}
              value={comentario}
              onChange={(event) => {
                if (subItem.tipo === 'avaliacao' || subItem.tipo === 'multiple') {
                  setComentario(event.target.value);
                  subItem.ocorrencia = event.target.value;
                } else {
                  subItem.obs = event.target.value;
                  setComentario(event.target.value);
                }
              }}
            />
          </Stack>
        );
      case 'chamado':
        return (
          openModal
          && <OpenTicketModal
            setSelectedOption={setSelectedOption}
            openModal={openModal}
            limite={subItem?.chamadosConfig?.limiteChamado}
            setOpenModal={setOpenModal}
            modelos={subItem?.chamadosConfig?.tipoChamado as unknown as modeloType[] ?? []}
            chamados={chamados}
            setChamados={setChamados}
          />
        );
    }
  };

  const ButtonInfo = ({ value, label, endIcon }: { value: string, label: string, endIcon: ReactNode }) => {
    return (
      <Button
        endIcon={endIcon}
        sx={changeStyle(value)}
        variant={selectedOption === value ? 'contained' : 'outlined'}
        size='small'
        onClick={() => {
          changeSelected(value);
          if (value === 'chamado') {
            setOpenModal(true);
          }
        }}>
        {label}
      </Button>
    );
  };

  const changeStyle = (value: string) => {
    const style = {
      backgroundColor: selectedOption === value ? '#643E91' : 'inherit',
      color: selectedOption === value ? '#fff' : '#643E91',
      borderColor: selectedOption === value ? '#643E91' : '#643E91',
      ':hover': {
        backgroundColor: selectedOption === value ? '#643E91' : 'inherit',
        color: selectedOption === value ? '#fff' : '#643E91',
        borderColor: selectedOption === value ? '#643E91' : '#643E91',
      }
    };
    return style;
  };

  const changeSelected = (value: string) => {
    setSelectedOption(value);
    if (selectedOption === value) {
      setSelectedOption('');
    }
  };

  return (
    <>
      {
        (
          <>
            {subItem.tipo !== 'avaliacao'
              ? <ButtonGroup size='small' sx={{ marginBottom: '10px', marginTop: '10px' }}>
                {subItem.foto && <ButtonInfo value='foto' label={t('ActionPlan.Modal.images').slice(0, -1)} endIcon={<AddPhotoAlternateIcon />} />}
                {subItem.comentario && <ButtonInfo value='comentario' label={t('notifications.ticket.Comentario')} endIcon={<AddCommentIcon />} />}
                {logado && subItem.permiteArquivo && <ButtonInfo value='arquivo' label={'Arquivos'} endIcon={<FolderOpenIcon />} />}
                {logado && subItem.chamadosConfig && subItem?.chamadosConfig?.tipoChamado.length > 0 && <ButtonInfo value='chamado' label={t('notifications.ticket.tickets')} endIcon={<GiAcousticMegaphone />} />}
              </ButtonGroup>
              : <ButtonGroup size='small' sx={{ marginBottom: '10px', marginTop: '10px' }}>
                {!subItem.hideImg && <ButtonInfo value='foto' label={t('ActionPlan.Modal.images').slice(0, -1)} endIcon={<AddPhotoAlternateIcon />} />}
                {!subItem.hideComent && <ButtonInfo value='comentario' label={t('notifications.ticket.Comentario')} endIcon={<AddCommentIcon />} />}
                {logado && subItem.permiteArquivo && <ButtonInfo value='arquivo' label={'Arquivos'} endIcon={<FolderOpenIcon />} />}
                {logado && subItem.chamadosConfig && subItem?.chamadosConfig?.tipoChamado.length > 0 && <ButtonInfo value='chamado' label={t('notifications.ticket.tickets')} endIcon={<GiAcousticMegaphone />} />}
              </ButtonGroup>}
            {renderDetails()}
          </>
        )
      }
    </>
  );
}
